<script setup lang="ts">
import RelationView from '@desktop/views/Relation/components/RelationView/RelationView.vue'
import { initSportConfiguration } from '@desktop/views/Relation/Sports/provide-inject'

import BaseballRelation from './components/RelationView/BaseballRelation.vue'
import BaseballStatistics from './components/RelationView/BaseballStatistics.vue'
import {
  useOnFinishedRegularTime,
  useOnFirstInningStarted,
} from './composables'
import {
  addIncidentConfig,
  customIncidentNames,
  eventInfoControls,
  eventRelatedStatusConfig,
  eventStatusIncidentsOnFieldConfig,
  historyFiltersConfig,
  historyIncidentsConfig,
  importantStatsId,
  incidentsCustomFiltersConfig,
  incidentsQueuePayloadConfig,
  incidentsResultConfig,
  lineupConfig,
  manualAddIncidentConfig,
  pitchIncidentsConfig,
  playersConfig,
  pocketIncidentsConfig,
  resultWithSliderConfig,
} from './configuration'

initSportConfiguration({
  addIncidentConfig,
  playersConfig,
  customIncidentNames,
  defaultSkinPatternId: 49,
  eventInfoControls,
  eventRelatedStatusConfig,
  hasChangeSides: false,
  historyFiltersConfig,
  historyIncidentsConfig,
  importantStatsId,
  incidentsCustomFiltersConfig,
  incidentsResultConfig,
  incidentsQueuePayloadConfig,
  lineupConfig,
  manualAddIncidentConfig,
  pitch: {
    eventStatusIncidentsOnFieldConfig,
    pitchIncidentsConfig,
  },
  pocketIncidentsConfig,
  resultWithSliderConfig,
  verifyResultSummaryConfig: {
    isDrawPossible: true,
    winnerOptions: {
      drawOptionLabel: 'N/A',
    },
  },
})

useOnFirstInningStarted()
useOnFinishedRegularTime()
</script>

<template>
  <RelationView
    :relation="BaseballRelation"
    :statistics="BaseballStatistics"
  />
</template>
